import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M17 1H7C6.20435 1 5.44129 1.34768 4.87868 1.96655C4.31607 2.58542 4 3.42479 4 4.3V19.7C4 20.5752 4.31607 21.4146 4.87868 22.0335C5.44129 22.6523 6.20435 23 7 23H17C17.7956 23 18.5587 22.6523 19.1213 22.0335C19.6839 21.4146 20 20.5752 20 19.7V4.3C20 3.42479 19.6839 2.58542 19.1213 1.96655C18.5587 1.34768 17.7956 1 17 1ZM18 19.7C18 19.9917 17.8946 20.2715 17.7071 20.4778C17.5196 20.6841 17.2652 20.8 17 20.8H7C6.73478 20.8 6.48043 20.6841 6.29289 20.4778C6.10536 20.2715 6 19.9917 6 19.7V4.3C6 4.00826 6.10536 3.72847 6.29289 3.52218C6.48043 3.31589 6.73478 3.2 7 3.2H17C17.2652 3.2 17.5196 3.31589 17.7071 3.52218C17.8946 3.72847 18 4.00826 18 4.3V19.7Z"
      fill={fill}
    />
    <path
      d="M12 19C12.8284 19 13.5 18.3284 13.5 17.5C13.5 16.6716 12.8284 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19Z"
      fill={fill}
    />
    <path
      d="M14.5 5H9.5C9.23478 5 8.98043 5.10536 8.79289 5.29289C8.60536 5.48043 8.5 5.73478 8.5 6C8.5 6.26522 8.60536 6.51957 8.79289 6.70711C8.98043 6.89464 9.23478 7 9.5 7H14.5C14.7652 7 15.0196 6.89464 15.2071 6.70711C15.3946 6.51957 15.5 6.26522 15.5 6C15.5 5.73478 15.3946 5.48043 15.2071 5.29289C15.0196 5.10536 14.7652 5 14.5 5Z"
      fill={fill}
    />
  </g>
);

export default Icon;
